/**
 * Validacao client-side reutilizavel para os campos de Promocao e Novidade do Item.
 *
 * Espelha as regras de negocio RN01-RN04 do backend (fonte da verdade:
 * `vendas/docs/api/API_CONTRACT_item-promocao-novidade.md`), oferecendo feedback
 * imediato ao usuario. O backend permanece a guarda final.
 *
 * Funcao pura (sem dependencia de Angular) para ser reutilizada pelos tres pontos
 * de cadastro/edicao de item, evitando divergencia de regra.
 */

export interface ValidacaoPromocaoNovidade {
  /** `true` quando nao ha erros. */
  ok: boolean;
  /** Chaves i18n a exibir (uma por erro), na ordem promocao -> novidade. */
  errosI18n: string[];
}

/**
 * Valida os campos de promocao/novidade conforme RN01-RN04.
 *
 * Regras:
 * - Se `promocao === true`:
 *   - `promocaoAteEm` nula            -> 'produtos.mensagens.promocao_data_final_obrigatoria'
 *   - `promocaoAteEm` <= agora        -> 'produtos.mensagens.promocao_data_final_deve_ser_futura'
 * - Se `novidade === true`:
 *   - `novidadeAteEm` nula            -> 'produtos.mensagens.novidade_data_final_obrigatoria'
 *   - `novidadeAteEm` <= agora        -> 'produtos.mensagens.novidade_data_final_deve_ser_futura'
 *
 * @param promocao       flag do switch de promocao
 * @param promocaoAteEm  Date|null vindo do p-calendar de promocao
 * @param novidade       flag do switch de novidade
 * @param novidadeAteEm  Date|null vindo do p-calendar de novidade
 * @param agora          injecao de "now" para testabilidade (default new Date())
 */
export function validarPromocaoNovidade(
  promocao: boolean,
  promocaoAteEm: Date | null,
  novidade: boolean,
  novidadeAteEm: Date | null,
  agora: Date = new Date(),
): ValidacaoPromocaoNovidade {
  const errosI18n: string[] = [];

  if (promocao === true) {
    if (promocaoAteEm == null) {
      errosI18n.push('produtos.mensagens.promocao_data_final_obrigatoria');
    } else if (promocaoAteEm.getTime() <= agora.getTime()) {
      errosI18n.push('produtos.mensagens.promocao_data_final_deve_ser_futura');
    }
  }

  if (novidade === true) {
    if (novidadeAteEm == null) {
      errosI18n.push('produtos.mensagens.novidade_data_final_obrigatoria');
    } else if (novidadeAteEm.getTime() <= agora.getTime()) {
      errosI18n.push('produtos.mensagens.novidade_data_final_deve_ser_futura');
    }
  }

  return { ok: errosI18n.length === 0, errosI18n };
}
